export default {
    STEP_VALUE: 25,
};
